import React, { Component } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import Button from "ati-ui-react/components/Button";
import { getFormattedDistance, getFormattedDate } from "../../bl/routeRowService";
import { MAP_POINT_TYPES } from "../../constants";
import styles from "./MapPopup.scss";
import {getMarkerIconTypeByVisit} from "../RouteMapPoint/RouteMapPoint.bl";
import {getAddressParts} from "../../utils/addressHelper";
import NODE_TYPES from "../../constants/nodeTypes";

class MapPopup extends Component {
  getPointTypeProperties = (visit) => {
    const { t } = this.props;
    const markerType = getMarkerIconTypeByVisit(visit);

    let icon = <div className={styles.commonPoint} />;
    let title = t("trace-map-point-type-passing", "Попутный населённый пункт");
    switch (markerType) {
      case MAP_POINT_TYPES.INTERMEDIATE_POINT:
        icon = <div className={styles.intermediatePoint}>{visit.passthroughIndex + 1}</div>;
        title = t("trace-map-point-type-intermediate", "Промежуточная точка");
        break;
      case MAP_POINT_TYPES.START_POINT:
        title = t("trace-map-point-type-start", "Начало маршрута");
        break;
      case MAP_POINT_TYPES.END_POINT:
        title = t("trace-map-point-type-end", "Конец маршрута");
        break;
      case MAP_POINT_TYPES.START_WITH_LOADING_POINT:
        title = t("trace-map-point-type-start-with-loading", "Начало маршрута с загрузкой");
        icon = <div className={styles.loadingPoint} />;
        break;
      case MAP_POINT_TYPES.END_WITH_UNLOADING_POINT:
        title = t("trace-map-point-type-end-with-unloading", "Конец маршрута с рагрузкой");
        icon = <div className={styles.unloadingPoint} />;
        break;
      case MAP_POINT_TYPES.LOADING_POINT:
        title = t("trace-map-point-type-loading", "Загрузка");
        icon = <div className={styles.loadingPoint} />;
        break;
      case MAP_POINT_TYPES.UNLOADING_POINT:
        title = t("trace-map-point-type-unloading", "Разгрузка");
        icon = <div className={styles.unloadingPoint} />;
        break;
      case MAP_POINT_TYPES.CUSTOMS:
        title = t("trace-map-point-type-customs", "Пограничный переход");
        icon = <div className={styles.customsPoint} />;
        break;
      case MAP_POINT_TYPES.COMMON_POINT:
      default:
        break;
    }

    return {
      icon,
      title
    };
  };
  
  render() {
    const { visitedRoutePoint, t, i18n } = this.props;
    const routePoint = visitedRoutePoint.routePoint;
    const visits = visitedRoutePoint.visits;
    const addressParts = getAddressParts(routePoint);
    const name = addressParts[0];
    const clarifyParts = addressParts[1];
    const passingPoint = routePoint.city && routePoint.nodeTypes === NODE_TYPES.passing;
    const onceVisitedPassthroughPoint = visits.length === 1 && visits[0].passthroughIndex !== undefined;
    const canExcludePoint = passingPoint || onceVisitedPassthroughPoint;

    const removePointText = passingPoint 
      ? t("trace-map-point-exclude-city-tooltip", "Удалить точку (в объезд)")
      : t("trace-map-point-remove-passthrough-node-tooltip", "Удалить точку");

    const removePointAction = passingPoint
      ? event => {
        event.stopPropagation();
        this.props.excludeCity(routePoint.city);
      }
      : event => {
        event.stopPropagation();
        this.props.excludePassthroughPoint(visits[0].passthroughIndex);
      };
    
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.primaryTitle}>
                {name}
          </div>
          {clarifyParts && (<div className={styles.secondaryTitle}>
            {clarifyParts}
          </div>)}
          {canExcludePoint && (
            <div className={styles.controls}>
              <Button
                className={styles.button}
                simpleDashed
                text={removePointText}
                action={removePointAction}
              />
            </div>
          )}
        </div>
        <div className={styles.body}>
          
          { visits.map((visit, index) => {
            const properties = this.getPointTypeProperties(visit);
            const format = t("trace-map-point-popover-date-format", "D MMMM в HH:mm");
            const distanceUnit = t("trace-common-units-kilometers-abbreviation", "км");
            const eta = getFormattedDate(visit.estimatedTimeOfArrival, format, i18n.language);
            const distance = t("trace-map-point-popover-distance", {
              defaultValue: "{{distance}} от начала",
              distance: getFormattedDistance(visit.totalDistance, distanceUnit),
            });
            return (
                <div className={styles.visit} key={`${eta}_${index}`}>
                  <div className={styles.date}>{eta}</div>
                  <div className={styles.distance}>{distance}</div>
                  <div className={styles.types}>
                    <div className={styles.type}>
                      <div className={styles.title}>
                        <div className={styles.icon}>{properties.icon}</div>
                        <div className={styles.text}>{properties.title}</div>
                      </div>
                    </div>
                  </div>
                </div>
            );
          })}
        </div>
      </div>
    );
  }
  
  static propTypes = {
    visitedRoutePoint: PropTypes.shape({
      visits: PropTypes.array.isRequired
    }).isRequired,
    t: PropTypes.func.isRequired,
    excludeCity: PropTypes.func.isRequired,
    excludePassthroughPoint: PropTypes.func.isRequired
  };
}

export default withNamespaces()(MapPopup);
